/* eslint-disable global-require */
import React, { useEffect } from 'react'
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  CardTitle,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Alert,
} from 'reactstrap'
import { useForm, ErrorMessage } from 'react-hook-form'
import { useHistory } from 'react-router-dom'
import axios from 'axios'
import NotificationAlert from 'react-notification-alert'
import Background from '../../assets/img/wic/Fruits_slides.jpg'

const sleep = milliseconds => {
  return new Promise(resolve => setTimeout(resolve, milliseconds))
}

const ForgotPassword = () => {
  const history = useHistory()

  useEffect(() => {
    document.body.classList.toggle('register-page')
    return () => {
      document.body.classList.toggle('register-page')
    }
  }, [history])

  const handleCancelClick = e => {
    e.preventDefault()

    history.push('/')
  }

  const notificationAlert = React.useRef()
  const notify = (message, messageType) => {
    let options = {
      place: 'bc',
      message: (
        <div>
          <h5>{message}</h5>
        </div>
      ),
      type: messageType,
      icon: 'nc-icon nc-bell-55',
      autoDismiss: 5,
    }
    notificationAlert.current.notificationAlert(options)
  }

  const sendPasswordReset = async email => {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    }

    const recoveryData = {
      username: email,
      factorType: 'EMAIL',
      relayState: 'https://aplss.wic.ca.gov',
    }

    await axios
      .post(
        `${window.config.oktaUrl}/v1/authn/recovery/password`,
        recoveryData,
        config
      )
      .then(async res => {
        console.log(res)
        notify('Please check inbox for an email to reset password.', 'success')
        await sleep(5000)
        history.push('/')
      })
      .catch(error => {
        console.log('error:' + JSON.stringify(error))
        notify('Password cannot be reset at this time.', 'danger')
      })
  }

  const onFormSubmit = async data => {
    await sendPasswordReset(data.email)
  }

  const { register, errors, handleSubmit } = useForm()

  return (
    <div className="register-page">
      <Container>
        <NotificationAlert ref={notificationAlert} />
        <Row>
          <Col className="ml-auto mr-auto" lg="8" md="10">
            <Form className="form" onSubmit={handleSubmit(onFormSubmit)}>
              <Card className="card-signup text-center">
                <CardHeader>
                  <CardTitle tag="h4">Forgot password?</CardTitle>
                </CardHeader>
                <CardBody>
                  <Row className="justify-content-center">
                    <Col className="pl-1" md="10">
                      <FormGroup>
                        <Label>Email address</Label>
                        <Input
                          name="email"
                          innerRef={register({
                            required: '⚠ Email is required',
                            pattern: {
                              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                              message: '⚠ Invalid email address',
                            },
                          })}
                        />
                      </FormGroup>
                      <p className={'text-danger'}>
                        <ErrorMessage
                          errors={errors}
                          name="email"
                          as={<Alert color={'danger'} className={'mt-3'} />}
                        />
                      </p>
                    </Col>
                  </Row>
                </CardBody>
                <CardFooter>
                  <Button className="btn-round mr-2" color="info">
                    Send recovery email
                  </Button>
                  <Button
                    className="btn-round ml-2"
                    color="danger"
                    href="#pablo"
                    onClick={handleCancelClick}
                  >
                    Cancel
                  </Button>
                </CardFooter>
              </Card>
            </Form>
          </Col>
        </Row>
      </Container>
      <div
        className="full-page-background"
        style={{
          backgroundImage: `url(${Background})`,
          opacity: 0.4,
        }}
      />
    </div>
  )
}

export default ForgotPassword
